import { render } from "./Header.vue?vue&type=template&id=1158e45c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1158e45c&lang=scss"
import "./Header.vue?vue&type=style&index=1&id=1158e45c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3281735233/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1158e45c"]])

export default __exports__